import {
  IOrganization,
  IOrganizationField,
  IGroup,
} from "../../models/organization.ts";
import { IOrganizationCsvFormat } from "../../models/organizationCsvFormat.ts";

export const transformFromOrganizationToCsv = (
  org: IOrganization,
  groupMap: Map<number, string>,
  activeFields: IOrganizationField[],
): IOrganizationCsvFormat => {
  const csv: IOrganizationCsvFormat = {
    name: org.name ?? "",
    external_id: org.external_id ?? "",
    notes: org.notes ?? "",
    domain_names: org.domain_names ? org.domain_names.join(" ") : "",
    shared: org.shared_tickets ? "True" : "False",
    shared_comments: org.shared_comments ? "True" : "False",
    group: org.group_id ? (groupMap.get(org.group_id) ?? "") : "",
    tags: org.tags ? org.tags.join("|") : "",
  };

  for (const field of activeFields) {
    const value = org.organization_fields?.[field.key];
    const headerKey = `organization_fields.${field.key}`;

    if (value === null || value === undefined) {
      csv[headerKey] = "";
    } else if (field.type === "checkbox") {
      csv[headerKey] = value ? "True" : "False";
    } else if (field.type === "multiselect" && typeof value === "string") {
      csv[headerKey] = value.replace(/,/g, "|");
    } else {
      csv[headerKey] = value;
    }
  }

  csv["_ref_id"] = org.id;
  csv["_ref_url"] = org.url ?? "";
  csv["_ref_details"] = org.details ?? "";
  csv["_ref_created_at"] = org.created_at ?? "";
  csv["_ref_updated_at"] = org.updated_at ?? "";

  return csv;
};

export const buildOrganizationCsvHeaders = (
  activeFields: IOrganizationField[],
): string[] => {
  const fixedHeaders = [
    "name",
    "external_id",
    "notes",
    "domain_names",
    "shared",
    "shared_comments",
    "group",
    "tags",
  ];

  const customHeaders = activeFields.map(
    (f) => `organization_fields.${f.key}`,
  );

  const refHeaders = [
    "_ref_id",
    "_ref_url",
    "_ref_details",
    "_ref_created_at",
    "_ref_updated_at",
  ];

  return [...fixedHeaders, ...customHeaders, ...refHeaders];
};

export const buildGroupMap = (groups: IGroup[]): Map<number, string> => {
  const map = new Map<number, string>();
  for (const g of groups) {
    map.set(g.id, g.name);
  }
  return map;
};
